// extracted by mini-css-extract-plugin
export var childrenContainer = "_dk-0";
export var virtualScrollArea = "_dk-1";